export default {
  'price.title': 'Preis',
  'price.originalPrice': 'Originalpreis',
  'price.currency': 'Währung',
  'price.originalPriceError': 'Originalpreis ist erforderlich',
  'price.discountedPrice': 'Rabattierter Preis',
  'price.discountBy': 'Rabatt um',
  'price.discountedCalc': 'Wird berechnet',
  'price.discounted': 'Rabattiert?',
  'price.trialed': 'Testversion?',
  'price.duration': 'Zahlungsdauer',
  'price.durationPeriod': 'Zeitraum',
  'price.discount': 'Zahlungsrabatt',
  'price.trialedDiscount': 'Testzeitraum-Rabatt',
  'price.discountInfo': 'Rabattinformationen {{header}}',
  'price.discountStartedAt': 'Beginnt am',
  'price.discountDuration': 'Rabattdauer',
  'price.trial': 'Test',
  'price.sale': 'Sale',
  'price.saleAt': 'Sale gestartet / abgelaufen (am)',
  'price.trialDuration': 'Dauer der Testversion',
  'price.trialPriceInfo': 'Testzeitraum',
  'price.priceInfo': '{{type}} Preisinformationen',
  'price.info.helper':
    'Setzen Sie den Originalpreis, wählen Sie die Währung, wenden Sie Rabatte an und definieren Sie Testdetails',
};
